import { missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'brandingCards-wrap-container';

export default function createBrandingCards() {
  const widgetName = 'brandingCards';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof brandingCardsOpts === 'undefined' ? null : brandingCardsOpts;

  if (!widgetOpts) {
    $('.wrapContainerClass').remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createBrandingCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createBrandingCards(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}
